import React from 'react'
import {TextField, type TextFieldVariants} from '@mui/material'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import {inputChecks} from './formikTextField.utils'
import _ from 'lodash'

interface FormikTextFieldProps {
    id: string
    placeholder?: string
    formik: any
    typeHTML?: string
    onChange?(...args: unknown[]): unknown
    onKeyDown?(...args: unknown[]): unknown
    blurHandler?(...args: unknown[]): unknown
    className?: string
    errorMsg?: string
    disabled?: boolean
    error?: boolean
    maxLength?: number
    autoFocus?: boolean
    fullWidth?: boolean
    startAdornment?: React.ReactElement
    isTouched?: boolean
    readOnly?: boolean
    onWheel?(...args: unknown[]): unknown
    variant?: TextFieldVariants
    onInput?(...args: unknown[]): unknown
    endAdornment?: React.ReactNode
    setAdornment?: any
}

const FormikTextField = ({
    id,
    placeholder,
    formik,
    typeHTML,
    className,
    onChange,
    onKeyDown,
    disabled,
    error,
    errorMsg,
    variant,
    maxLength,
    autoFocus,
    fullWidth,
    blurHandler,
    startAdornment,
    setAdornment,
    isTouched,
    readOnly,
    onWheel,
    onInput
}: FormikTextFieldProps) => {
    const handleInputChange = (e) => {
        const inputValue = e.target.value
        formik.setFieldValue(id, inputChecks(inputValue, id))
        if (onChange) {
            onChange(e)
        }
    }

    const onBlurHandler = () => {
        formik.setFieldTouched(id)
        if (blurHandler) blurHandler()
    }

    const showErrMsg = () => {
        if ((isTouched ?? _.get(formik.touched, id)) && Boolean(errorMsg)) {
            return (
                <>
                    <ErrorOutlineOutlinedIcon className='formik-error__info-icon' />
                    {errorMsg}
                </>
            )
        } else if ((isTouched ?? _.get(formik.touched, id)) && !!_.get(formik.errors, id)) {
            return (
                <>
                    <ErrorOutlineOutlinedIcon className='formik-error__info-icon' />
                    {_.get(formik.errors, id)}
                </>
            )
        }
    }

    return (
        <TextField
            id={id}
            name={id}
            placeholder={placeholder}
            value={_.get(formik.values, id)}
            onChange={handleInputChange}
            onBlur={onBlurHandler}
            error={
                isTouched && !!errorMsg
                    ? errorMsg
                    : _.get(formik.touched, id) && Boolean(errorMsg)
                        ? _.get(formik.touched, id) && Boolean(errorMsg)
                        : _.get(formik.touched, id) && Boolean(_.get(formik.errors, id))
            }
            helperText={showErrMsg()}
            type={typeHTML}
            InputProps={{
                startAdornment,
                inputProps: {
                    maxLength,
                    onWheel
                },
                readOnly,
                endAdornment: setAdornment !== false ? setAdornment : <React.Fragment />
            }}
            className={className}
            disabled={disabled}
            autoFocus={autoFocus}
            fullWidth={fullWidth}
            variant={variant}
            onKeyDown={onKeyDown}
            onInput={onInput}
        />
    )
}

FormikTextField.defaultProps = {
    type: 'textfield',
    typeHTML: 'text',
    showAstrik: true,
    setAdornment: <div />,
    changeHandler: null,
    blurHandler: () => {},
    onKeyDown: () => {},
    variant: 'outlined',
    disabled: false,
    maxLength: 300,
    autoFocus: false,
    fullWidth: false,
    startAdornment: null,
    isTouched: false,
    readOnly: false
}

export default FormikTextField
